import {
	StyledCameraErrorContainer,
	StyledCameraErrorImage,
	StyledCameraErrorMessage,
	StyledCameraErrorTitle,
	StyledCameraErrorSectionButton,
	StyledCameraErrorButton
} from 'components/Selfiebooth/CameraError/styled'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isFacebookApp } from 'utils/index'
import { MdFileUpload } from 'react-icons/md'
import { SelfieBoothType } from '../../../types/selfiebooth'
import useFileUpload from '../hooks/useFileUpload'

interface CameraErrorProps {
	selfiebooth: SelfieBoothType;
	onUploadPhoto: (fileUrl: string) => void;
}

const CameraError = ({ selfiebooth, onUploadPhoto }: CameraErrorProps) => {
	const { part: infos } = selfiebooth;
	const { t, i18n } = useTranslation();
	const { inputRef, openFilePicker, handleFileUpload } = useFileUpload(onUploadPhoto);

	useEffect(() => {
		i18n.changeLanguage(infos.shareAdmin.language);
	}, [infos.shareAdmin.language, i18n]);

	return <>
		<StyledCameraErrorContainer>
			<StyledCameraErrorTitle>
				{infos.onError.header || t('photobooth.oups')}
			</StyledCameraErrorTitle>
			<StyledCameraErrorImage src="/static/photobooth/msj/stickers/soulager.svg" />
			<StyledCameraErrorMessage>
				{infos.onError.message || t('photobooth.message')}
			</StyledCameraErrorMessage>
			<br />
			<p>{isFacebookApp() && t('photobooth.facebookBrowser')}</p>

			{infos.inputPhoto && <>
        <StyledCameraErrorSectionButton>
          <StyledCameraErrorButton onClick={openFilePicker}>
            <label>{infos.onError.photo || t('photobooth.photo')}</label>
            <MdFileUpload />
          </StyledCameraErrorButton>
          <input
            type="file"
            ref={inputRef}
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
        </StyledCameraErrorSectionButton>
      </>}
		</StyledCameraErrorContainer>
	</>
}

export default CameraError;